import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelExecution } from "../types";

const POLLING_INTERVAL = 5000; // 5 seconds

export const useClientModelsExecutionStatus = (model_ids: string[]) => {
  return useQuery({
    queryKey: ["client", "models", "execution_status", model_ids],
    enabled: model_ids.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/execution/status?model_id=${model_ids.join("&model_id=")}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelExecution[];
        })
        .catch((error) => {
          return handleAPIError(error);
        }),
    refetchInterval: (query) => {
      // Only poll if the response was successful (status 200) and there are models with status other than SUCCEEDED or FAILED
      const data = query.state.data as ClientModelExecution[] | undefined;

      const isSuccess = query.state.fetchFailureReason === null;

      if (data === undefined || !isSuccess) return false;

      const hasModelsInProgress = data.some(
        (model) => model.status !== "SUCCEEDED" && model.status !== "FAILED"
      );

      return hasModelsInProgress ? POLLING_INTERVAL : false;
    }
  });
};
